import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=5bd24a62&scoped=true"
import script from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonPrimary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=5bd24a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd24a62",
  null
  
)

export default component.exports